module.exports = __webpack_public_path__ + "static/media/teaching_icon_4.e60a7e02.svg";